import * as React from 'react';
import { Row, Col } from '../../uiComponents/bootstrap-components/BootstrapComponents';
import { ImageFromBlob } from '../../uiComponents/layout/ImageFromBlob';
import { Header } from '../../uiComponents/layout/Header';
import { getSkoleAar } from '../../models/SkoleAar';
import TableFormatters from '../../uiComponents/table/TableFormatters';
import { Image } from '../../uiComponents/layout/Image';
import { KonkurrenceBeskrivelse } from '../../uiComponents/KonkurrenceBeskrivelse';
import { LinkPrimaryButton } from '../../uiComponents/input/Buttons';
import { Opgavepakke } from '../../models/Opgavepakke';
import { KonkurrenceAfviklingssted } from '../../models/KonkurrenceAfviklingssted';

export interface KonkurrenceJumbotronProps {
    konkurrenceTitel: string;
    konkurrenceDate: Date;
    konkurrenceAfviklingssted?: KonkurrenceAfviklingssted;
    billedId: string;
    opgavepakkeNavn: string;
    samletPlacering: number;
    konkurrenceId: string;
    beskrivelse: string;
    showSamletPlacering: boolean;
    opgavepakkeIds: string[];
    opgavepakker?: Opgavepakke[];
    isEkstern?: boolean;
}

function getKonkurrencePlaceringEllerBeskrivelseEllerHoldlisteknap(props: KonkurrenceJumbotronProps) {
    if (props.isEkstern) {
        const holdlisteUrl = '/tilmeldte-hold/' + props.konkurrenceId;
        return (
            <Col md={4} className='konkurrence-jumbotron-info konkurrence-jumbotron-holdliste-container'>
                <div className='konkurrence-jumbotron-info-wrapper konkurrence-jumbotron-se-holdliste'>
                    <LinkPrimaryButton text={'Se holdliste'} url={holdlisteUrl} />
                </div>
            </Col>
        );
    }

    if (!props.showSamletPlacering) {
        return (
            <Col md={4} className='konkurrence-jumbotron-beskrivelse'>
                <div className='konkurrence-jumbotron-beskrivelse-wrapper'>
                    <Header type='h4' className='beskrivelse-header'>Konkurrencebeskrivelse</Header>
                    <KonkurrenceBeskrivelse beskrivelse={props.beskrivelse} />
                </div>
            </Col>
        );
    }

    return (
        <Col md={4} className='konkurrence-jumbotron-placering'>
            <div className='konkurrence-jumbotron-placering-wrapper'>
                {props.samletPlacering !== -1 &&
                    <div>
                        <div className='placering-image-wrapper'>
                            <Image className='placering-image' source='placering.png' />
                            <p className='placering'>{props.samletPlacering}</p>
                        </div>
                        <Header className='placering-header' type='h3'>Samlet placering - {props.opgavepakkeNavn}</Header>
                    </div>
                }
            </div>
        </Col>);
}

function getKonkurrencedagInformation(props: KonkurrenceJumbotronProps) {
    let formattedDate = '';
    if(props.konkurrenceDate !== undefined){
        let date = new Date(props.konkurrenceDate);
        formattedDate = TableFormatters.getShortDate(date);
    }

    if (props.konkurrenceAfviklingssted !== undefined) {
        return (
            <div>
                <br />
                <Header type='h4'>Konkurrencedag</Header>
                <p>{formattedDate}</p>
                <br />
                <p>{props.konkurrenceAfviklingssted.afviklingssted}</p>
                <p>{props.konkurrenceAfviklingssted.adresse} </p>
                <p>{props.konkurrenceAfviklingssted.postnummer} {props.konkurrenceAfviklingssted.bynavn}</p>
            </div>
        );
    }

    return undefined;
}

export function KonkurrenceJumbotron(props: KonkurrenceJumbotronProps) {
    let skoleaar = '';
    
    if (props.konkurrenceDate !== undefined) {
        let date = new Date(props.konkurrenceDate);
        skoleaar = getSkoleAar(date);
    }

    return (
        <div className='konkurrence-jumbotron'>
            <Row>
                <Col md={4} className='konkurrence-jumbotron-image'>
                    <ImageFromBlob id={props.billedId} />
                </Col>
                <Col md={4} className='konkurrence-jumbotron-info'>
                    <div className='konkurrence-jumbotron-info-wrapper'>
                        <Header type='h2'>{props.konkurrenceTitel}</Header>
                        <Header type='h2'>{skoleaar}</Header>
                        {getKonkurrencedagInformation(props)}
                    </div>
                </Col>
                {getKonkurrencePlaceringEllerBeskrivelseEllerHoldlisteknap(props)}
            </Row>
        </div>
    );
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/pageComponents/konkurrence/KonkurrenceJumbotron.tsx